<section class="authentication__inner">
    <router-outlet></router-outlet>
</section>


